import React, { useEffect } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import { useCallback } from "react";
import { useState } from "react";
import { useRef } from "react";
import data from "./data";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import {
  checkNumber,
  checkShortKey,
  checkSpecialChar,
  checkString,
  emailValidation,
} from "../utilities/FormValidation";
import { grey } from "@mui/material/colors";
import FormPageHeader from "../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import { toast } from "react-toastify";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CustomTooltip from "./customTooltip";
import jwtDecode from "jwt-decode";
import Decline from "./Decline";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .total-list": {
      padding: "0px 5px",
      justifyContent: "space-between",

      "& li": {
        padding: "5px",
        fontSize: "12px",
        width: "100%",

        "& label": {
          fontSize: "12px",
          color: "#fff !important",
          paddingBottom: "2px",
          display: "block",
        },
      },
    },
  },
}));

const territoryOptions = [
  { value: "territory1", label: "Territory 1" },
  { value: "territory2", label: "Territory 2" },
  { value: "territory3", label: "Territory 3" },
  { value: "territory4", label: "Territory 4" },
];
const customerOptions = [
  { value: "12345678", label: "12345678" },
  { value: "58794584", label: "58794584" },
  { value: "89571254", label: "89571254" },
  { value: "02354012", label: "02354012" },
];
const vendorOptions = [
  { value: "NK", label: "NK" },
  { value: "NE", label: "NE" },
];
const commissionNameOptions = [
  {
    value: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    label: "HS300101-NK-K1-SHEKARGOUDA-BLR",
  },
  {
    value: "HS300101-NK-K2-SHEKARGOUDA-BLR",
    label: "HS300101-NK-K2-SHEKARGOUDA-BLR",
  },
];
const statusOptions = [
  { value: "All", label: "All" },
  { value: "WAITING", label: "WAITING" },
  { value: "PENDING", label: "PENDING" },
  { value: "APPROVED", label: "APPROVED" },
  { value: "REJECTED", label: "REJECTED" },
];

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;

export default function SpecialDiscountApproval(props) {
  const classes = useStyles(props);
  const [rowData, setRowData] = useState(data);
  const gridRef = useRef();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const perPage = 20;
  const [gridApi, setGridApi] = useState(null);
  const [wg1SDR, setWg1SDR] = useState("");
  const [wg2SDR, setWg2SDR] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [validError, setValidError] = useState({});
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [territoryFilter, setTerritoryFilter] = useState(null);
  const [customerFilter, setCustomerFilter] = useState(null);
  const [vendorFilter, setVendorFilter] = useState(null);
  const [commissionNameFilter, setCommissionNameFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [autoSizeMode, setAutoSizeMode] = useState(true);
  const [hideSDRColumns, setHideSDRColumns] = useState(true);
  const [hideSDPColumns, setHideSDPColumns] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const DeclineComponent = (props) => {
    const [open, setOpen] = useState(false);
    const { data } = props;
    const rowNode = data.api.getRowNode(data.node.id);
    const handleDialogOpen = () => {
      setOpen(true);
      if (rowNode) {
        rowNode.setDataValue("status", "REJECTED");
      }
    };
    const handleClose = () => {
      setOpen(false);
    };
    return (
      <>
        <Tooltip title={"Decline"}>
          <IconButton onClick={handleDialogOpen}>
            <FuseSvgIcon size={14} color="action">
              heroicons-outline:x
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Decline
          open={open}
          onClose={handleClose}
          content={`Order ${data.data?.abNumber} special discount decline`}
        />
      </>
    );
  };

  const showStatusIcon = (props) => {
    let statusIcon = "";
    if (props.data.status === "PENDING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fe9705", marginRight: 4 }}>
            material-solid:access_time_filled
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props.data.status === "WAITING") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#fcd260", marginRight: 4 }}>
            material-solid:timelapse
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props.data.status === "APPROVED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#3ac430", marginRight: 4 }}>
            material-solid:check_circle
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    if (props.data.status === "REJECTED") {
      statusIcon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: "#d11313", marginRight: 4 }}>
            material-solid:cancel
          </FuseSvgIcon>
          {props.value}
        </>
      );
    }
    return (
      <p className="flex items-center">
        {props.column.colId === "customerNum" && props.value
          ? statusIcon
          : props.value}
      </p>
    );
  };
  const showDiscountPercent = (props) => {
    return <p>{props.value && <>{Number(props?.value).toFixed(3)}%</>}</p>;
  };
  const showFixedValue = (props) => {
    return <p>{props.value && <>{Number(props?.value).toFixed(2)}</>}</p>;
  };
  const RcblStdDiscWg1 = (props) => {
    return (
      100 -
      ((100 - Number(props.data?.stdDiscWg1)) *
        (100 - Number(props.data?.spclDiscWg1))) /
        100
    );
  };
  const cumDiscWg1 = (props) => {
    return (
      100 -
      ((100 - Number(props.data?.stdDiscWg1 + props.data?.spclDiscWg1)) *
        (100 - Number(props.data?.sdrWg1))) /
        100
    );
  };
  const rcblStdDiscWg2 = (params) => {
    return (
      100 -
      ((100 - Number(params.data?.stdDiscWg2)) *
        (100 - Number(params.data?.spclDiscWg2))) /
        100
    );
  };
  const cumDiscWg2 = (params) => {
    return (
      100 -
      ((100 - Number(params.data?.stdDiscWg2 + params.data?.spclDiscWg2)) *
        (100 - Number(params.data?.sdrWg2))) /
        100
    );
  };
  const shouldHideColumn = () => {
    return token.scope.includes("ROLE_ORDERPRO") ? true : false;
  };
  const [columnDefsSDR, setColumnDefsSDR] = useState([
    // { field: 'Group', editable: false, cellRenderer: (params) => showStatusIcon(params), },
    {
      field: "customerNum",
      headerName: "Customer",
      rowGroup: true,
      hide: true,
      //   enableRowGroup: true,
      //   rowGroup: true,
      //   minWidth: 110,
      //   cellRenderer: (params) => showStatusIcon(params),
      //   hide: shouldHideColumn(),
    },
    {
      field: "showroomName",
      headerName: "Showroom",
      minWidth: 70,
      cellRenderer: (params) => showStatusIcon(params),
    },
    {
      field: "vendorShortKey",
      headerName: "Product",

      minWidth: 60,
    },
    { field: "orderCategory", headerName: "Category", minWidth: 60 },
    { field: "abNumber", minWidth: 75 },
    { field: "commissionName", minWidth: 215 },
    {
      field: "lpWg1",
      headerName: "List Price Wg1",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "lpWg2",
      headerName: "List Price Wg2",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "totalLpWg1Wg2",
      headerName: "Total List Price",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "rcblStdDiscWg1",
      headerName: "RCBL STD DISC.WG1",

      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      valueGetter: RcblStdDiscWg1,
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
    },
    {
      field: "sdrWg1",
      headerName: "SDR WG1",

      cellClass: "bg-blue",
      editable: token.scope.includes("ROLE_ORDERPRO") ? false : true,
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      valueFormatter: (params) =>
        params.data?.sdrWg1 === null ? 0 : params.data?.sdrWg1,
      valueGetter: (params) =>
        params.data?.sdrWg1 === null ? 0 : params.data?.sdrWg1,
    },
    {
      field: "cumDiscWg1",

      headerName: "CUM.DISC WG1",
      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: cumDiscWg1,
      // valueGetter: (params) => params.data?.sdrWg1
    },
    {
      field: "rcblStdDiscWg2",

      headerName: "RCBL STD DISC.WG2",
      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: rcblStdDiscWg2,
    },
    {
      field: "sdrWg2",
      headerName: "SDR WG2",

      cellClass: "bg-blue",
      editable: token.scope.includes("ROLE_ORDERPRO") ? false : true,
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "cumDiscWg2",

      headerName: "CUM.DISC WG2",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-green",
      minWidth: 70,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: cumDiscWg2,
    },
    {
      field: "nmeRcbl",

      headerName: "NFZE RCBL",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.pblCumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg2 / 100)),
    },
    {
      field: "nmeRcblStd",
      headerName: "NFZE RCBL (STD)",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.rcblStdDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.cumDiscWg2 / 100)),
    },
    {
      field: "nmeRcblAfterSdr",

      headerName: "NFZE RCBL (AFTER SDR)",
      cellClass: "bg-green",
      minWidth: 80,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.cumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg1 / 100)),
      // (params.data.lpWg1 - (params.data.lpWg1 * params.data.CUMDiscountWG1)) + (params.data.lpWg2 - (params.data.lpWg2 * params.data.pblCumDiscWg1))
    },
    {
      field: "stdMargin",

      headerName: "STD MARGIN.",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) => params.data?.nmeRcblStd - params.data?.nmeRcbl,
    },
    {
      field: "marginAftSplDisc",

      headerName: "MARGIN AFT SPL DISC",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.nmeRcblAfterSdr - params.data?.nmeRcbl,
    },
    {
      field: "marginAftSplDiscPercent",

      headerName: "% MARGIN AFT SPL DISC",
      cellClass: "bg-green",
      minWidth: 80,
      cellRenderer: showDiscountPercent,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.marginAftSplDisc / params.data?.nmeRcblAfterSdr,
    },
    {
      field: "gestureToCustomer",

      headerName: "GESTURE TO CUSTOMER",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmeRcblStd / params.data?.nmeRcblAfterSdr,
    },
    {
      field: "gesture",

      headerName: "% GESTURE",
      valueFormatter: (params) =>
        params.data?.gestureToCustomer / params.data?.nmeRcblStd,
      cellRenderer: showDiscountPercent,
      cellClass: "bg-green",
      minWidth: 70,
    },
    { field: "document", minWidth: 60 },
    {
      field: "status",
      minWidth: 70,
      filter: "agTextColumnFilter",
      //   filter: "agTextColumnFilter",
      //   filterParams: {
      //     filterOptions: ['equals']
      //   }
    },
    { field: "remarks", minWidth: 100, editable: true },
    {
      field: "decline",
      minWidth: 60,
      editable: false,
      cellRenderer: (data) => <DeclineComponent data={data} />,
      hide: shouldHideColumn(),
    },
  ]);
  const [columnDefsSDP, setColumnDefsSDP] = useState([
    // { field: 'Group', editable: false, cellRenderer: (params) => showStatusIcon(params), },
    {
      field: "customerNum",
      headerName: "Customer",
      rowGroup: true,
      hide: true,
      //   enableRowGroup: true,
      //   rowGroup: true,
      //   minWidth: 110,
      //   cellRenderer: (params) => showStatusIcon(params),
      //   hide: shouldHideColumn(),
    },
    {
      field: "showroomName",
      headerName: "Showroom",
      minWidth: 70,
      cellRenderer: (params) => showStatusIcon(params),
    },
    {
      field: "vendorShortKey",
      headerName: "Product",

      minWidth: 60,
    },
    { field: "orderCategory", headerName: "Category", minWidth: 60 },
    { field: "abNumber", minWidth: 75 },
    { field: "commissionName", minWidth: 215 },
    {
      field: "lpWg1",
      headerName: "List Price Wg1",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "lpWg2",
      headerName: "List Price Wg2",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "totalLpWg1Wg2",
      headerName: "Total List Price",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "pblStdDiscWg1",

      headerName: "PBL STD DISC.WG1",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.discWG1Payable)) *
          (100 - Number(params.data?.splDiscWG1Payable))) /
          100,
    },
    {
      field: "sdpWg1",
      headerName: "SDP WG1",

      cellClass: "bg-blue",
      editable: true,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "pblCumDiscWg1",
      headerName: "PBL CUM DISC WG1",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.pblStdDiscWg1)) *
          (100 - Number(params.data?.sdpWg1))) /
          100,
    },
    {
      field: "pblStdDiscWg2",

      headerName: "PBL STD DISC WG2",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.discWG2Payable)) *
          (100 - Number(params.data?.splDiscWG2Payable))) /
          100,
    },
    {
      field: "sdpWg2",
      headerName: "SDP WG2",

      cellClass: "bg-blue",
      editable: true,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "pblCumDiscWg2",

      headerName: "PBL CUM DISC WG2",
      cellClass: "bg-orange",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      hide: shouldHideColumn(),
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.pblStdDiscWg2)) *
          (100 - Number(params.data?.sdpWg2))) /
          100,
    },
    {
      field: "nmePbl",

      headerName: "NFZE PBL",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.pblCumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg2 / 100)),
    },
    {
      field: "nmePblStd",

      headerName: "NFZE PBL (STD)",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.rcblStdDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.cumDiscWg2 / 100)),
    },
    {
      field: "nmePblAfterSdr",

      headerName: "NFZE PBL (AFTER SDR)",
      cellClass: "bg-orange",
      minWidth: 80,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.cumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg1 / 100)),
      // (params.data.lpWg1 - (params.data.lpWg1 * params.data.CUMDiscountWG1)) + (params.data.lpWg2 - (params.data.lpWg2 * params.data.pblCumDiscWg1))
    },
    {
      field: "stdPblMargin",

      headerName: "STD MARGIN.",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) => params.data?.nmePblStd - params.data?.nmePbl,
    },
    {
      field: "pblMarginAftSplDisc",

      headerName: "NFZE MARGIN AFT SPL DISC",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmePblAfterSdr - params.data?.nmePbl,
    },
    {
      field: "pblMarginAftSplDiscPercent",

      headerName: "%NFZE MARGIN",
      cellClass: "bg-orange",
      minWidth: 80,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      valueGetter: (params) =>
        params.data?.pblMarginAftSplDisc / params.data?.nmePblAfterSdr,
    },
    {
      field: "gestureToPbl",

      headerName: "NFZE GESTURE",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmePblStd / params.data?.nmePblAfterSdr,
    },
    {
      field: "gesturePbl",

      headerName: "NFZE PER GESTURE",
      valueFormatter: (params) =>
        params.data?.gestureToPbl / params.data?.nmePblStd,
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      hide: shouldHideColumn(),
      minWidth: 70,
    },
    { field: "document", minWidth: 60 },
    {
      field: "status",
      minWidth: 70,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["equals"],
      },
    },
    { field: "remarks", minWidth: 100, editable: true },
    {
      field: "decline",
      minWidth: 60,
      editable: false,
      cellRenderer: (data) => <DeclineComponent data={data} />,
      hide: shouldHideColumn(),
    },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    // { field: 'Group', editable: false, cellRenderer: (params) => showStatusIcon(params), },
    {
      field: "customerNum",
      headerName: "Customer",
      rowGroup: true,
      hide: true,
      //   enableRowGroup: true,
      //   rowGroup: true,
      //   minWidth: 110,
      //   cellRenderer: (params) => showStatusIcon(params),
      //   hide: shouldHideColumn(),
    },
    {
      field: "showroomName",
      headerName: "Showroom",
      minWidth: 70,
      cellRenderer: (params) => showStatusIcon(params),
    },
    {
      field: "vendorShortKey",
      headerName: "Product",

      minWidth: 60,
    },
    { field: "orderCategory", headerName: "Category", minWidth: 60 },
    { field: "abNumber", minWidth: 75 },
    { field: "commissionName", minWidth: 215 },
    {
      field: "lpWg1",
      headerName: "List Price Wg1",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "lpWg2",
      headerName: "List Price Wg2",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "totalLpWg1Wg2",
      headerName: "Total List Price",
      minWidth: 70,
      cellRenderer: showFixedValue,
    },
    {
      field: "rcblStdDiscWg1",
      headerName: "RCBL STD DISC.WG1",

      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      valueGetter: RcblStdDiscWg1,
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
    },
    {
      field: "sdrWg1",
      headerName: "SDR WG1",

      cellClass: "bg-blue",
      editable: token.scope.includes("ROLE_ORDERPRO") ? false : true,
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      valueFormatter: (params) =>
        params.data?.sdrWg1 === null ? 0 : params.data?.sdrWg1,
      valueGetter: (params) =>
        params.data?.sdrWg1 === null ? 0 : params.data?.sdrWg1,
    },
    {
      field: "cumDiscWg1",

      headerName: "CUM.DISC WG1",
      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: cumDiscWg1,
      // valueGetter: (params) => params.data?.sdrWg1
    },
    {
      field: "rcblStdDiscWg2",

      headerName: "RCBL STD DISC.WG2",
      cellClass: "bg-green",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: rcblStdDiscWg2,
    },
    {
      field: "sdrWg2",
      headerName: "SDR WG2",

      cellClass: "bg-blue",
      editable: token.scope.includes("ROLE_ORDERPRO") ? false : true,
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "cumDiscWg2",

      headerName: "CUM.DISC WG2",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-green",
      minWidth: 70,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: cumDiscWg2,
    },
    {
      field: "pblStdDiscWg1",

      headerName: "PBL STD DISC.WG1",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.discWG1Payable)) *
          (100 - Number(params.data?.splDiscWG1Payable))) /
          100,
    },
    {
      field: "sdpWg1",
      headerName: "SDP WG1",

      cellClass: "bg-blue",
      editable: true,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "pblCumDiscWg1",

      headerName: "PBL CUM DISC WG1",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.pblStdDiscWg1)) *
          (100 - Number(params.data?.sdpWg1))) /
          100,
    },
    {
      field: "pblStdDiscWg2",

      headerName: "PBL STD DISC WG2",
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      tooltipField: "rcblStdDiscWg1",
      tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.discWG2Payable)) *
          (100 - Number(params.data?.splDiscWG2Payable))) /
          100,
    },
    {
      field: "sdpWg2",
      headerName: "SDP WG2",

      cellClass: "bg-blue",
      editable: true,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      minWidth: 70,
    },
    {
      field: "pblCumDiscWg2",

      headerName: "PBL CUM DISC WG2",
      cellClass: "bg-orange",
      cellRenderer: showDiscountPercent,
      minWidth: 70,
      hide: shouldHideColumn(),
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        100 -
        ((100 - Number(params.data?.pblStdDiscWg2)) *
          (100 - Number(params.data?.sdpWg2))) /
          100,
    },
    {
      field: "nmeRcbl",

      headerName: "NFZE RCBL",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.pblCumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg2 / 100)),
    },
    {
      field: "nmeRcblStd",
      headerName: "NFZE RCBL (STD)",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.rcblStdDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.cumDiscWg2 / 100)),
    },
    {
      field: "nmeRcblAfterSdr",

      headerName: "NFZE RCBL (AFTER SDR)",
      cellClass: "bg-green",
      minWidth: 80,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.cumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg1 / 100)),
      // (params.data.lpWg1 - (params.data.lpWg1 * params.data.CUMDiscountWG1)) + (params.data.lpWg2 - (params.data.lpWg2 * params.data.pblCumDiscWg1))
    },
    {
      field: "stdMargin",

      headerName: "STD MARGIN.",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) => params.data?.nmeRcblStd - params.data?.nmeRcbl,
    },
    {
      field: "marginAftSplDisc",

      headerName: "MARGIN AFT SPL DISC",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.nmeRcblAfterSdr - params.data?.nmeRcbl,
    },
    {
      field: "marginAftSplDiscPercent",

      headerName: "% MARGIN AFT SPL DISC",
      cellClass: "bg-green",
      minWidth: 80,
      cellRenderer: showDiscountPercent,
      // tooltipField: 'rcblStdDiscWg1', tooltipComponentParams: { color: '#eb2e2e' }, tooltipComponent: CustomTooltip,
      valueGetter: (params) =>
        params.data?.marginAftSplDisc / params.data?.nmeRcblAfterSdr,
    },
    {
      field: "gestureToCustomer",

      headerName: "GESTURE TO CUSTOMER",
      cellClass: "bg-green",
      minWidth: 70,
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmeRcblStd / params.data?.nmeRcblAfterSdr,
    },
    {
      field: "gesture",

      headerName: "% GESTURE",
      valueFormatter: (params) =>
        params.data?.gestureToCustomer / params.data?.nmeRcblStd,
      cellRenderer: showDiscountPercent,
      cellClass: "bg-green",
      minWidth: 70,
    },
    {
      field: "nmePbl",

      headerName: "NFZE PBL",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.pblCumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg2 / 100)),
    },
    {
      field: "nmePblStd",

      headerName: "NFZE PBL (STD)",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.rcblStdDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.cumDiscWg2 / 100)),
    },
    {
      field: "nmePblAfterSdr",

      headerName: "NFZE PBL (AFTER SDR)",
      cellClass: "bg-orange",
      minWidth: 80,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.lpWg1 -
        params.data?.lpWg1 * (params.data?.cumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg1 / 100)),
      // (params.data.lpWg1 - (params.data.lpWg1 * params.data.CUMDiscountWG1)) + (params.data.lpWg2 - (params.data.lpWg2 * params.data.pblCumDiscWg1))
    },
    {
      field: "stdPblMargin",

      headerName: "STD MARGIN.",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) => params.data?.nmePblStd - params.data?.nmePbl,
    },
    {
      field: "pblMarginAftSplDisc",

      headerName: "NFZE MARGIN AFT SPL DISC",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmePblAfterSdr - params.data?.nmePbl,
    },
    {
      field: "pblMarginAftSplDiscPercent",

      headerName: "%NFZE MARGIN",
      cellClass: "bg-orange",
      minWidth: 80,
      hide: shouldHideColumn(),
      cellRenderer: showDiscountPercent,
      valueGetter: (params) =>
        params.data?.pblMarginAftSplDisc / params.data?.nmePblAfterSdr,
    },
    {
      field: "gestureToPbl",

      headerName: "NFZE GESTURE",
      cellClass: "bg-orange",
      minWidth: 70,
      hide: shouldHideColumn(),
      cellRenderer: showFixedValue,
      valueGetter: (params) =>
        params.data?.nmePblStd / params.data?.nmePblAfterSdr,
    },
    {
      field: "gesturePbl",

      headerName: "NFZE PER GESTURE",
      valueFormatter: (params) =>
        params.data?.gestureToPbl / params.data?.nmePblStd,
      cellRenderer: showDiscountPercent,
      cellClass: "bg-orange",
      hide: shouldHideColumn(),
      minWidth: 70,
    },
    { field: "document", minWidth: 60 },
    {
      field: "status",
      minWidth: 70,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["equals"],
      },
    },
    { field: "remarks", minWidth: 100, editable: true },
    {
      field: "decline",
      minWidth: 60,
      editable: false,
      cellRenderer: (data) => <DeclineComponent data={data} />,
      hide: shouldHideColumn(),
    },
  ]);

  // useEffect(() => {
  //   setColumnDefs()
  // }, [rowData])

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(url);
      const data = list.data?._embedded.orders;
      setRowData(data);
    } catch (error) {
      setError(error.message);
    }
  };

  // useEffect(() => {
  //   if (gridApi) {
  //       loadData();
  //   }
  // }, [gridApi]);

  const toggleSDRColumns = () => {
    const columnsToHide = ["orderCategory", "showroomName", "abNumber"];
    setHideSDRColumns(!hideSDRColumns);
    columnsToHide.forEach((columnId) => {
      gridRef.current.columnApi.setColumnVisible(columnId, !hideSDRColumns);
    });
  };
  const toggleSDPColumns = () => {
    const columnsToHide = [
      "pblStdDiscWg1",
      "sdpWg1",
      "pblCumDiscWg1",
      "pblStdDiscWg2",
      "sdpWg2",
      "pblCumDiscWg2",
      "pblCumDiscWg2",
      "gesturePbl",
      "gestureToPbl",
      "pblMarginAftSplDiscPercent",
      "pblMarginAftSplDisc",
      "stdPblMargin",
      "nmePblAfterSdr",
      "nmePblStd",
      "nmePbl",
    ];
    setHideSDPColumns(!hideSDPColumns);
    columnsToHide.forEach((columnId) => {
      gridRef.current.columnApi.setColumnVisible(columnId, !hideSDPColumns);
    });
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "SpecialDiscount.xlsx",
      sheetName: "SpecialDiscount",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const handlePendingStatus = useCallback(() => {
    var statusFilterComponent = gridRef.current.api.getFilterInstance("status");
    console.log(statusFilterComponent);
    statusFilterComponent.setModel({ type: "equal", filter: "APPROVED" });
    gridRef.current.api.onFilterChanged();
  }, []);

  const headerInputFields = () => {
    return (
      <>
        {token.scope.includes("ROLE_MD") && (
          <>
            <div
              onClick={handlePendingStatus}
              class="flex flex-col items-center justify-center py-10 px-10 rounded-2xl bg-indigo-50 text-indigo-800 cursor-pointer"
            >
              <Typography
                variant="body1"
                className="text-3xl font-semibold leading-none tracking-tight"
              >
                214
              </Typography>
              <Typography variant="body1" className="mt-4 text-sm font-medium">
                Pending
              </Typography>
            </div>
            <div class="flex flex-col items-center justify-center py-10 px-10 rounded-2xl bg-green-50 text-indigo-800 cursor-pointer">
              <Typography
                variant="body1"
                className="text-3xl font-semibold leading-none tracking-tight"
              >
                214
              </Typography>
              <Typography variant="body1" className="mt-4 text-sm font-medium">
                Approved
              </Typography>
            </div>
          </>
        )}
        {(token.scope.includes("ROLE_IAM") ||
          token.scope.includes("ROLE_ADMIN") ||
          token.scope.includes("ROLE_MD") ||
          token.scope.includes("ROLE_SOPDIR")) && (
          <div>
            <div className="flex items-center">
              <div className="ml-16">
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      checked={hideSDRColumns}
                      onChange={toggleSDRColumns}
                    />
                  }
                  label="SDR Analysis"
                  sx={{ mr: 0, "& .MuiCheckbox-root": { p: 0 } }}
                />
              </div>
              <div className="ml-16">
                <label className="pt-6 pr-6 inline-block">WG1 SDR</label>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  className="w-[120px]"
                  value={wg1SDR}
                  onChange={(e) => {
                    setWg1SDR(e.target.value);
                    setValidError({
                      ...validError,
                      wg1SDR: checkNumber(e.target.value),
                    });
                  }}
                  error={
                    (checkSubmit && !wg1SDR) || validError.wg1SDR ? true : false
                  }
                  helperText={
                    checkSubmit && !wg1SDR
                      ? "This field is required"
                      : validError.wg1SDR
                  }
                  InputLabelProps={{
                    shrink: wg1SDR ? true : false,
                  }}
                />
              </div>
              <div className="ml-16">
                <label className="pt-6 pr-6 inline-block">WG2 SDR</label>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  className="w-[120px]"
                  value={wg2SDR}
                  onChange={(e) => setWg2SDR(e.target.value)}
                />
              </div>
              <div className="ml-16">
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleUpdateCellValue}
                  style={{ marginBottom: "5px", fontWeight: "bold" }}
                >
                  DISTRIBUTE
                </Button>
              </div>
              <div className="ml-16">
                <Tooltip title={"SDR EMAIL TO MD"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{ marginBottom: "5px", fontWeight: "bold" }}
                    onClick={handleSave}
                    disabled={btnDisabled}
                  >
                    <FuseSvgIcon>heroicons-outline:mail</FuseSvgIcon>
                  </Button>
                </Tooltip>
              </div>
            </div>
            <div className="flex items-center">
              <div className="ml-16">
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      checked={hideSDPColumns}
                      onChange={toggleSDPColumns}
                    />
                  }
                  label="SDP Analysis"
                  sx={{ "& .MuiCheckbox-root": { p: 0 } }}
                />
              </div>
              <div>
                <label className="pt-6 pr-6 inline-block">WG1 SDR</label>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  className="w-[120px]"
                  value={wg1SDR}
                  onChange={(e) => {
                    setWg1SDR(e.target.value);
                    setValidError({
                      ...validError,
                      wg1SDR: checkNumber(e.target.value),
                    });
                  }}
                  error={
                    (checkSubmit && !wg1SDR) || validError.wg1SDR ? true : false
                  }
                  helperText={
                    checkSubmit && !wg1SDR
                      ? "This field is required"
                      : validError.wg1SDR
                  }
                  InputLabelProps={{
                    shrink: wg1SDR ? true : false,
                  }}
                />
              </div>
              <div className="ml-16">
                <label className="pt-6 pr-6 inline-block">WG2 SDR</label>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  className="w-[120px]"
                  value={wg2SDR}
                  onChange={(e) => setWg2SDR(e.target.value)}
                />
              </div>
              <div className="ml-16">
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleUpdateCellValue}
                  style={{ marginBottom: "5px", fontWeight: "bold" }}
                >
                  DISTRIBUTE
                </Button>
              </div>
              <div className="ml-16">
                <Tooltip title={"SDR EMAIL TO MD"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{ marginBottom: "5px", fontWeight: "bold" }}
                    onClick={handleSave}
                    disabled={btnDisabled}
                  >
                    <FuseSvgIcon>heroicons-outline:mail</FuseSvgIcon>
                  </Button>
                </Tooltip>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };
  const handleSave = () => {
    toast.success("Discount Send Successfully");
  };
  const onSelectionChanged = (params) => {
    const selectedNodes = gridApi.getSelectedNodes();
    setSelectedRows(selectedNodes.map((node) => node.data));
    // setSelectedRows(params.api.getSelectedRows());
  };
  const handleUpdateCellValue = () => {
    // setCheckSubmit(true)
    if (selectedRows.length > 0) {
      const colId1 = "sdrWg1";
      const colId2 = "sdrWg2";
      const updateData = rowData.map((row) =>
        selectedRows.find((selectedRow) => selectedRow.id === row.id)
          ? {
              ...row,
              [colId1]: wg1SDR !== "" ? wg1SDR : row?.sdrWg1,
              [colId2]: wg2SDR !== "" ? wg2SDR : row?.sdrWg2,
            }
          : row
      );
      setRowData(updateData);
      // gridApi.setDatasource(updateData)
      setShowAlert(false);
      setWg1SDR("");
      setWg2SDR("");
      // setCheckSubmit(false)
    } else {
      setShowAlert(true);
    }
  };

  //   const onRowValueChanged = useCallback((event) => {
  //     let data = event.data;

  //     data.rcblStdDiscWg1 = 555
  //     console.log('RowValueChanged', data)

  //     // gridRef.current.api.refreshCells();
  //     // const changedData = updateData.push(data);
  //     // setRowData([data]);
  // }, [gridApi]);

  const totalPrice = rowData.reduce((a, b) => Number(a + b.totalLpWg1Wg2), 0);
  const totalRCBLasPerPDS = rowData.reduce(
    (a, b) => Number(a + b.nmeRcblStd),
    0
  );
  const totalRCBAfterSDR = rowData.reduce(
    (a, b) => Number(a + b.nmeRcblAfterSdr),
    0
  );
  const totalGestureToCustomer = totalRCBLasPerPDS - totalRCBAfterSDR;
  const totalPercentageGestureToCustomer =
    (totalGestureToCustomer / totalRCBLasPerPDS) * 100;
  const totalMarginAsPerPDS = rowData.reduce(
    (a, b) => Number(a + b.stdMargin),
    0
  );
  const totalAfterSDR = rowData.reduce(
    (a, b) => Number(a + b.marginAftSplDisc),
    0
  );
  const totalPercentageMargin = (totalAfterSDR / totalRCBAfterSDR) * 100;
  const totalPblAsPerPds = rowData.reduce((a, b) => Number(a + b.nmePblStd), 0);
  const totalPBLAfterSDP = rowData.reduce(
    (a, b) => Number(a + b.nmePblAfterSdr),
    0
  );
  const totalGestureFromFac = rowData.reduce(
    (a, b) => Number(a + b.gestureToPbl),
    0
  );
  const totalPercentageGestureToPbl =
    (totalGestureFromFac / totalPblAsPerPds) * 100;

  const handleVendorChange = useCallback((e) => {
    setVendorFilter({ value: e.value, label: e.label });
    var vendorFilterComponent =
      gridRef.current.api.getFilterInstance("product");
    vendorFilterComponent.setModel({ type: "equal", filter: [e.value] });
    gridRef.current.api.onFilterChanged();
  }, []);

  const handleCustomerChange = useCallback((e) => {
    setCustomerFilter({ value: e.value, label: e.label });
    var vendorFilterComponent =
      gridRef.current.api.getFilterInstance("customer");
    vendorFilterComponent.setModel({ type: "equal", filter: [e.value] });
    gridRef.current.api.onFilterChanged();
  }, []);

  const handleCommissionNameChange = useCallback((e) => {
    setCommissionNameFilter({ value: e.value, label: e.label });
    var vendorFilterComponent =
      gridRef.current.api.getFilterInstance("commissionName");
    vendorFilterComponent.setModel({ type: "equal", filter: [e.value] });
    gridRef.current.api.onFilterChanged();
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatusFilter({ value: e.value, label: e.label });
    var vendorFilterComponent = gridRef.current.api.getFilterInstance("status");
    vendorFilterComponent.setModel({ type: "equal", filter: [e.value] });
    gridRef.current.api.onFilterChanged();
  }, []);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [selectedRows]);

  const toggleAutoSize = () => {
    if (gridRef.current) {
      if (autoSizeMode) {
        const allColumnIds = [];
        gridRef.current.columnApi.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.columnApi.autoSizeColumns(allColumnIds);
      } else {
        gridRef.current.api.sizeColumnsToFit();
      }
      setAutoSizeMode(!autoSizeMode);
    }
  };

  const onCellValueChanged = (params) => {
    const { colDef, data, newValue } = params;
    // console.log('params', params)
    // console.log('colDef', colDef)
    // console.log('data', data)
    // console.log('newValue', newValue)
    if (colDef.field === "sdrWg1") {
      const cumDiscWg1 =
        100 -
        ((100 - Number(data.rcblStdDiscWg1)) * (100 - Number(newValue))) / 100;
      console.log("cumDiscWg1", cumDiscWg1);
      const nmeRcblAfterSdr =
        params.data?.lpWg1 -
        params.data?.lpWg1 * (cumDiscWg1 / 100) +
        (params.data?.lpWg2 -
          params.data?.lpWg2 * (params.data?.pblCumDiscWg1 / 100));
      console.log("nmeRcblAfterSdr", nmeRcblAfterSdr);
      const updatedRowData = rowData.map((row) =>
        row.id === params.data.id
          ? {
              ...row,
              cumDiscWg1: cumDiscWg1,
              nmeRcblAfterSdr: nmeRcblAfterSdr,
            }
          : row
      );
      setRowData(updatedRowData);
      // console.log('updatedRowData', updatedRowData)
      // const updatedValue = 100 - (((100 - data.rcblStdDiscWg1) * (100 - newValue)) / 100); // 100 - (((100 - params.data?.rcblStdDiscWg1) * (100 - params.data?.sdrWg1)) / 100)
      // data.cumDiscWg1 = updatedValue
      // console.log('updatedValue', updatedValue)
      // gridApi.refreshCells()
    }
  };
  const isGroupOpenByDefault = useCallback((params) => {
    return params.field === "customerNum" && params.key === "HS-INDIA";
  }, []);

  return (
    <>
      <FormPageHeader
        componentName="Special Discount Management"
        pageName="Special Discount Management"
        currentPage="Special Discount Management"
        // onBtExport={onBtExport}
        // handlePurge={handlePurge}
        // error={error}
        // successMsg={successMsg}
        // deleteDisable={deleteDisable}
        // snackState={snackState}
        // showPaginationDropdown={false}
        orderHeaderAction={headerInputFields()}
      >
        <Box className="flex px-16 justify-between" sx={{ pb: 1 }}>
          <Box sx={{ px: 1 }} className="w-full">
            <Select
              required
              placeholder="Territory"
              //   defaultInputValue='Territory'
              options={territoryOptions}
              value={territoryFilter}
              onChange={(e) =>
                setTerritoryFilter({ value: e.value, label: e.label })
              }
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <Select
              required
              placeholder="Customer"
              //   defaultInputValue="Customer"
              options={customerOptions}
              value={customerFilter}
              onChange={handleCustomerChange}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <Select
              required
              placeholder="Vendor"
              //   defaultInputValue="Vendor"
              options={vendorOptions}
              value={vendorFilter}
              onChange={handleVendorChange}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <Select
              required
              placeholder="Commission Name"
              //   defaultInputValue="Commission Name"
              options={commissionNameOptions}
              value={commissionNameFilter}
              onChange={handleCommissionNameChange}
              styles={customStyles()}
              className="w-[230px]"
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <CustomDatePicker
              label="From"
              className="w-full"
              format={"dd-MM-yyyy"}
              name={"fromDate"}
              // value={fromDate}
              // handleChange={handleFromDateChange}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <CustomDatePicker
              label="To"
              className="w-full"
              format={"dd-MM-yyyy"}
              name={"toDate"}
              // value={toDate}
              // minDate={fromDate}
              // handleChange={handleToDateChange}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
          </Box>
          <Box sx={{ px: 1 }} className="w-full">
            <Select
              required
              placeholder="Status"
              //   defaultInputValue="Status"
              options={statusOptions}
              value={statusFilter}
              onChange={handleStatusChange}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ pr: 1 }}>
            <Button
              //   onClick={handleAdvanceSearch}
              variant="contained"
              color="primary"
              size="small"
              sx={{ fontSize: 11 }}
            >
              Search
            </Button>
          </Box>
          <Box className="w-full">
            <Button
              onClick={toggleAutoSize}
              variant="contained"
              color="error"
              size="small"
              sx={{ fontSize: 11 }}
            >
              {autoSizeMode ? "Auto-Size Columns" : "Reset Columns"}
            </Button>
          </Box>
        </Box>
      </FormPageHeader>
      {token.scope.includes("ROLE_MD") && (
        <>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="inherit"
            sx={{ color: "yellow" }}
            variant="scrollable"
            scrollButtons="auto"
            classes={{ root: "w-full border-b-1" }}
          >
            <Tab label="SDR" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
            <Tab label="SDP" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
            <Tab label="PSD" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          </Tabs>
          <div
            className={clsx(classes.root, tabValue !== 0 ? "hidden" : "h-full")}
          >
            <div style={{ height: "calc(100% - 99px)" }}>
              {showAlert && (
                <Alert severity="error">Please select order first!</Alert>
              )}
              <AgGridTable
                columnDefs={columnDefsSDR}
                onGridReady={onGridReady}
                // default
                onSelectionChanged={onSelectionChanged}
                gridRef={gridRef}
                rowData={rowData}
                wrapHeaderText={true}
                autoHeaderHeight={true}
                onCellValueChanged={onCellValueChanged}
                domLayout={"autoHeight"}
                groupAllowUnbalanced={true}
                groupDisplayType={"groupRows"}
                suppressRowTransform={true}
                isGroupOpenByDefault={isGroupOpenByDefault}
                editable={false}
              />
            </div>
            <Box sx={{ background: grey[800] }}>
              <ul className="flex total-list">
                <li>
                  <label>Total List Price</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPrice.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBLasPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalGestureToCustomer.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageGestureToCustomer.toFixed(2)}%
                  </Box>
                </li>
                <li>
                  <label>Margin as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalMarginAsPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Margin</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageMargin.toFixed(2)}%
                  </Box>
                </li>
              </ul>
              <Divider />
              <ul className="flex total-list">
                <li>
                  <label>Total Orders</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {rowData.length}
                  </Box>
                </li>
                {hideSDPColumns ||
                  ((token.scope.includes("ROLE_IAM") ||
                    token.scope.includes("ROLE_ADMIN") ||
                    token.scope.includes("ROLE_MD") ||
                    token.scope.includes("ROLE_SOPDIR")) && (
                    <>
                      <li>
                        <label>PBL as per PDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPblAsPerPds.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>PBL as per SDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPBLAfterSDP.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>Gesture from factory</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalGestureFromFac.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>% Gesture on PBL</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPercentageGestureToPbl.toFixed(2)}%
                        </Box>
                      </li>
                    </>
                  ))}
                <li>
                  <label>Margin after SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li></li>
              </ul>
            </Box>
          </div>
          <div
            className={clsx(classes.root, tabValue !== 1 ? "hidden" : "h-full")}
          >
            <div style={{ height: "calc(100% - 99px)" }}>
              {showAlert && (
                <Alert severity="error">Please select order first!</Alert>
              )}
              <AgGridTable
                columnDefs={columnDefsSDP}
                onGridReady={onGridReady}
                // default
                onSelectionChanged={onSelectionChanged}
                gridRef={gridRef}
                rowData={rowData}
                wrapHeaderText={true}
                autoHeaderHeight={true}
                onCellValueChanged={onCellValueChanged}
                domLayout={"autoHeight"}
                groupAllowUnbalanced={true}
                groupDisplayType={"groupRows"}
                suppressRowTransform={true}
              />
            </div>
            <Box sx={{ background: grey[800] }}>
              <ul className="flex total-list">
                <li>
                  <label>Total List Price</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPrice.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBLasPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalGestureToCustomer.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageGestureToCustomer.toFixed(2)}%
                  </Box>
                </li>
                <li>
                  <label>Margin as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalMarginAsPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Margin</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageMargin.toFixed(2)}%
                  </Box>
                </li>
              </ul>
              <Divider />
              <ul className="flex total-list">
                <li>
                  <label>Total Orders</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {rowData.length}
                  </Box>
                </li>
                {hideSDPColumns ||
                  ((token.scope.includes("ROLE_IAM") ||
                    token.scope.includes("ROLE_ADMIN") ||
                    token.scope.includes("ROLE_MD") ||
                    token.scope.includes("ROLE_SOPDIR")) && (
                    <>
                      <li>
                        <label>PBL as per PDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPblAsPerPds.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>PBL as per SDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPBLAfterSDP.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>Gesture from factory</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalGestureFromFac.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>% Gesture on PBL</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPercentageGestureToPbl.toFixed(2)}%
                        </Box>
                      </li>
                    </>
                  ))}
                <li>
                  <label>Margin after SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li></li>
              </ul>
            </Box>
          </div>
          <div
            className={clsx(classes.root, tabValue !== 2 ? "hidden" : "h-full")}
          >
            <div style={{ height: "calc(100% - 99px)" }}>
              {showAlert && (
                <Alert severity="error">Please select order first!</Alert>
              )}
              <AgGridTable
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                // default
                onSelectionChanged={onSelectionChanged}
                gridRef={gridRef}
                rowData={rowData}
                wrapHeaderText={true}
                autoHeaderHeight={true}
                onCellValueChanged={onCellValueChanged}
                domLayout={"autoHeight"}
                groupAllowUnbalanced={true}
                groupDisplayType={"groupRows"}
                suppressRowTransform={true}
              />
            </div>
            <Box sx={{ background: grey[800] }}>
              <ul className="flex total-list">
                <li>
                  <label>Total List Price</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPrice.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBLasPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>RCBL as per SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalRCBAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalGestureToCustomer.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Gesture to Cust.</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageGestureToCustomer.toFixed(2)}%
                  </Box>
                </li>
                <li>
                  <label>Margin as per PDS</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalMarginAsPerPDS.toFixed(2)}
                  </Box>
                </li>
                <li>
                  <label>% Margin</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalPercentageMargin.toFixed(2)}%
                  </Box>
                </li>
              </ul>
              <Divider />
              <ul className="flex total-list">
                <li>
                  <label>Total Orders</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {rowData.length}
                  </Box>
                </li>
                {hideSDPColumns ||
                  ((token.scope.includes("ROLE_IAM") ||
                    token.scope.includes("ROLE_ADMIN") ||
                    token.scope.includes("ROLE_MD") ||
                    token.scope.includes("ROLE_SOPDIR")) && (
                    <>
                      <li>
                        <label>PBL as per PDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPblAsPerPds.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>PBL as per SDS</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPBLAfterSDP.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>Gesture from factory</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalGestureFromFac.toFixed(2)}
                        </Box>
                      </li>
                      <li>
                        <label>% Gesture on PBL</label>
                        <Box
                          sx={{
                            background: "#000",
                            px: 1.5,
                            py: 0.2,
                            borderRadius: 8,
                          }}
                        >
                          {totalPercentageGestureToPbl.toFixed(2)}%
                        </Box>
                      </li>
                    </>
                  ))}
                <li>
                  <label>Margin after SDR</label>
                  <Box
                    sx={{
                      background: "#000",
                      px: 1.5,
                      py: 0.2,
                      borderRadius: 8,
                    }}
                  >
                    {totalAfterSDR.toFixed(2)}
                  </Box>
                </li>
                <li></li>
              </ul>
            </Box>
          </div>
        </>
      )}
      {/* <div className={clsx(classes.root, "h-full")}>
        
      </div> */}
    </>
  );
}
